import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import PropTypes from 'prop-types';
import map from '../../node_modules/ramda/es/map.js';
import path from '../../node_modules/ramda/es/path.js';
import find from '../../node_modules/ramda/es/find.js';
import merge from '../../node_modules/ramda/es/merge.js';
import { NavFrame, mapLinks } from './shared.js';
import HeaderMailModal from '../HeaderMailModal/index.js';

var NavDefinition = function NavDefinition(_ref) {
  var options = _ref.options,
    comp = _ref.comp,
    vertical = _ref.vertical,
    b = _ref.b,
    l = _ref.l,
    isLoggedIn = _ref.isLoggedIn,
    _ref$meEmailMigration = _ref.meEmailMigrationData,
    meEmailMigrationData = _ref$meEmailMigration === void 0 ? {} : _ref$meEmailMigration,
    onToggleDoNotShowAgain = _ref.onToggleDoNotShowAgain,
    me = _ref.me;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    modalType = _useState4[0],
    setModalType = _useState4[1];
  var modalToggle = function modalToggle() {
    return setOpen(!modalOpen);
  };
  return /*#__PURE__*/React__default.createElement(NavFrame, {
    vertical: vertical
  }, /*#__PURE__*/React__default.createElement(HeaderMailModal, {
    open: modalOpen,
    onToggle: modalToggle,
    type: modalType,
    meEmailMigrationData: meEmailMigrationData,
    onToggleDoNotShowAgain: onToggleDoNotShowAgain,
    me: me
  }), mapLinks(options, comp, vertical, b, l, {
    isLoggedIn: isLoggedIn,
    meEmailMigrationData: meEmailMigrationData,
    setModalType: setModalType,
    setOpen: setOpen
  }));
};
NavDefinition.propTypes = {
  options: PropTypes.array.isRequired,
  comp: PropTypes.func,
  vertical: PropTypes.bool,
  b: PropTypes.number,
  l: PropTypes.number
};
NavDefinition.displayName = "Nav";
var Nav = NavDefinition;
var buildNavTree = function buildNavTree(mainOptions, subOptions) {
  return map(function (option) {
    return merge(option, {
      options: path(["options"], find(function (sub) {
        return sub.parent === option.id;
      }, subOptions))
    });
  }, mainOptions);
};

export { Nav, buildNavTree };
